export const POSITIONS_KEY = 'apiboo.graph.positions.v1';

export const MAX_LABELS = 140;

export const MIN_ZOOM = 0.05;

export const MAX_ZOOM = 6;

export const DIM = 0.16;

// Focus fade (owner: "smooth transition when it dims"): exponential ease with
// this time constant — ~95% of the way in 3·τ ≈ 200 ms, the same at any frame
// rate. It always animates, including under OS reduced motion, which the
// owner's Windows reports.
export const FADE_TAU_MS = 65;

export function loadPositions() {
  try {
    return JSON.parse(localStorage.getItem(POSITIONS_KEY) || '{}') || {};
  } catch {
    return {};
  }
}

export function savePositions(map) {
  try {
    localStorage.setItem(POSITIONS_KEY, JSON.stringify(map));
  } catch {
    /* storage full or blocked — layout just starts fresh next time */
  }
}

/** Evaluate the S-curve of link i at t ∈ [0,1] into out[o], out[o+1]. */
export function curvePoint(ax, ay, bx, by, bend, t, out, o) {
  const dx = bx - ax;
  const dy = by - ay;
  // Perpendicular offset, opposite at the two control points → a soft "snake".
  const nx = -dy * bend;
  const ny = dx * bend;
  const c1x = ax + dx / 3 + nx;
  const c1y = ay + dy / 3 + ny;
  const c2x = ax + (2 * dx) / 3 - nx;
  const c2y = ay + (2 * dy) / 3 - ny;
  const u = 1 - t;
  const a = u * u * u;
  const b = 3 * u * u * t;
  const c = 3 * u * t * t;
  const d = t * t * t;
  out[o] = a * ax + b * c1x + c * c2x + d * bx;
  out[o + 1] = a * ay + b * c1y + c * c2y + d * by;
}
